import { Route, Routes } from "react-router-dom";
import AdminArticleManagement from "routes/admin/AdminArticleManagement";
import AdminDashboard from "routes/admin/AdminDashboard";
import AdminLayout from "routes/admin/AdminLayout";
import AdminOrderManagement from "routes/admin/AdminOrderManagement";
import AdminProductManagement from "routes/admin/AdminProductManagement";
import AdminPromotionManagement from "routes/admin/AdminPromotionManagement";
import AdminStatisticsManagement from "routes/admin/AdminStatisticsManagement";
import AdminUserManagement from "routes/admin/AdminUserManagement";
import OrderStatusDetailLayout from "routes/admin/order/OrderStatusDetailLayout";
import ProductManagementLayout from "routes/admin/product/ProductManagementLayout";
import ProductRegisterDetailLayout from "routes/admin/product/page/ProductRegisterDetailLayout";
import StockManagementLayout from "routes/admin/product/page/StockManagementLayout";

import UserInfoManagementLayout from "routes/admin/user/UserInfoManagementLayout";

import AdminLogin from "components/manager/views/pages/admin/login/adminLogin";
import AdminChatManagement from "routes/admin/AdminChatManagement";
import ArticleManagementLayout from "routes/admin/article/ArticleManagementLayout";
import ArticleRegisterDetail from "routes/admin/article/ArticleRegisterDetail";
import ChatManagementLayout from "routes/admin/chat/ChatManagementLayout";
import OrderCacledTax from "routes/admin/order/OrderCalcedTax";
import PromotionManagementLayout from "routes/admin/promotion/PromotionManagementLayout";
import PromotionRegister from "routes/admin/promotion/PromotionRegister";
import UserGroupManagement from "routes/admin/user/UserGroupManagement";
import EmptyPage from "routes/empty/EmptyPage";
import RequireAdminAuth from "shared/utils/RequireAdminAuth";
import ProductSalesStatistics from "routes/admin/vendor/sales/ProductSalesStatistics";
import AccountSalesStatistics from "routes/admin/vendor/sales/AccountSalesStatistics";

function AdminRouter({ allowedRoles }) {
  return (
    <Routes>
      <Route
        path=""
        element={<RequireAdminAuth allowedRoles={"admin"} to="/admin/login" />}
      >
        <Route path="" element={<AdminLayout />}>
          {/* 홈 */}
          <Route path="" element={<AdminDashboard />} />
          {/* 주문 */}
          <Route path="orderManagement" element={<AdminOrderManagement />} />
          <Route
            path="orderStatus/:keyword"
            element={<OrderStatusDetailLayout />}
          />
          <Route path="orderCalcedTax" element={<OrderCacledTax />} />
          {/* 상품  */}
          <Route
            path="productManagement"
            element={<AdminProductManagement />}
          />
          <Route
            path="productStatus/:keyword"
            element={<ProductManagementLayout />}
          />
          <Route
            path="productRegistration"
            element={<ProductRegisterDetailLayout />}
          />

          <Route path="stockManagement" element={<StockManagementLayout />} />
          {/* 고객 */}
          <Route path="userManagement" element={<AdminUserManagement />} />
          <Route
            path="userInfoManagement/:keyword"
            element={<UserInfoManagementLayout />}
          />
          <Route path="userGroupManagement" element={<UserGroupManagement />} />
          {/* 게시글 */}
          <Route
            path="articleManagement"
            element={<AdminArticleManagement />}
          />
          <Route
            path="articleStatus/:keyword"
            element={<ArticleManagementLayout />}
          />
          <Route
            path="articleRegistration"
            element={<ArticleRegisterDetail />}
          />
          {/* 프로모션 */}
          <Route
            path="promotionManagement"
            element={<AdminPromotionManagement />}
          />
          <Route path="promotion/register" element={<PromotionRegister />} />
          <Route
            path="promotionStatus/:id"
            element={<PromotionManagementLayout />}
          />
          {/* 통계 */}
          <Route
            path="statisticsManagement"
            element={<AdminStatisticsManagement />}
          />
          <Route path="product" element={<ProductSalesStatistics />} />
          <Route path="customer" element={<AccountSalesStatistics />} />
          {/* 채팅 */}
          <Route path="chatManagement" element={<AdminChatManagement />} />
          <Route path="chatStatus" element={<ChatManagementLayout />} />
        </Route>
      </Route>
      <Route path="login" element={<AdminLogin />} />
      <Route path="*" element={<EmptyPage target="/admin" />} />
    </Routes>
  );
}
export default AdminRouter;
